export const HOME_ONBOARDING_TARGETS = {
  aiTools: "ai-tools-joyride",
  jobs: "jobs-joyride",
  profile: "profile-joyride",
}
